import type React from "react";

import {useLevelV2} from "~/api/hooks/useLevelV2";
import MedalDisplay from "~/component/common/MedalDisplay";
import {useGroupSession} from "~/contexts/session/GroupSessionProvider";
import MainActionButton from "~/routes/page/play-level/buttons/MainActionButton";
import PerformanceInformation from "~/routes/page/play-level/play-menu/PerformanceInformation";

interface CoopMenuContentProps {
  closeModal: () => void;
}

const CoopMenuContent: React.FC<CoopMenuContentProps> = ({closeModal}) => {
  const {sessionData} = useGroupSession();
  const levelId = sessionData?.current_round?.levelId;
  const {data: level} = useLevelV2({id: levelId});

  return (
    <div className="w-full text-white">
      {/* Top Section */}
      <div className="mb-4 text-center">
        <h2 className="text-3xl">{level?.name ?? "Unknown Level"}</h2>
      </div>

      {/* Performance Information and Medal Display */}
      <MedalDisplay levelId={levelId} />
      <PerformanceInformation levelId={levelId} />

      {/* Main Action Button */}
      <MainActionButton closeModal={closeModal} />
    </div>
  );
};

export default CoopMenuContent;
